import React from "react";
import styled from "styled-components";

const PortraitWrapper = styled.div`
  height: 450px;
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

const PortraitImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  border-radius: 5px;
`;

const Portrait = ({ imageSrc, altText }) => {
  return (
    <PortraitWrapper>
      <PortraitImage src={imageSrc} alt={altText} />
    </PortraitWrapper>
  );
};

export default Portrait;
